// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ModelAssociationFromJSON, ModelAssociationToJSON, TaTransparencyFromJSON, TaTransparencyToJSON, } from './';
export function TaBaseFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'modelName': !exists(json, 'modelName') ? undefined : json['modelName'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'asOfDate': !exists(json, 'asOfDate') ? undefined : new Date(json['asOfDate']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'lastUpdated': !exists(json, 'lastUpdated') ? undefined : new Date(json['lastUpdated']),
        'defaultFor': !exists(json, 'defaultFor') ? undefined : json['defaultFor'].map(ModelAssociationFromJSON),
        'assetClass': !exists(json, 'assetClass') ? undefined : json['assetClass'],
        'strategy': !exists(json, 'strategy') ? undefined : json['strategy'],
        'transparency': !exists(json, 'transparency') ? undefined : TaTransparencyFromJSON(json['transparency']),
    };
}
export function TaBaseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'modelName': value.modelName,
        'name': value.name,
        'asOfDate': value.asOfDate === undefined ? undefined : value.asOfDate.toISOString().substr(0, 10),
        'description': value.description,
        'lastUpdated': value.lastUpdated === undefined ? undefined : value.lastUpdated.toISOString().substr(0, 10),
        'defaultFor': value.defaultFor === undefined ? undefined : value.defaultFor.map(ModelAssociationToJSON),
        'assetClass': value.assetClass,
        'strategy': value.strategy,
        'transparency': TaTransparencyToJSON(value.transparency),
    };
}
